/**
 * This component is the My Charges page.  It is a light wrapper for the Charges component.
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Paper } from '@mui/material';

import Charges from '../account/Charges';
import PageTitle from '../ui/PageTitle';
import ChargesCustomer from '../account/ChargesCustomer';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  paper: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
    textAlign: 'left',
    color: theme.palette.text.secondary,
    marginTop: 16,
  },
  flex: {
    flex: 1,
  },
});

class MyCharges extends Component {
  render() {
    const { isAuthenticated, isAuthenticatedCustomer, isUnauthenticatedCustomer, isAuthenticatedReseller, isAuthenticatedAppBind, needAssent } = this.props.auth;
    const classes = this.props.classes;


    if ((!isAuthenticated() && !isUnauthenticatedCustomer()) || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedAppBind()) {
      return (
        <div>
          <PageTitle title="My charges" subtitle="Report of charges for your app subscriptions." />
          <p>TBD goes here</p>
        </div>
      );
    } else if (isAuthenticatedReseller() || isAuthenticatedCustomer() || isUnauthenticatedCustomer()) {
      let acctId = abEnvironment.getUserAttribute("a_id");

      return (
        <div className={classes.root}>
          <PageTitle title="My charges" subtitle="Report of charges for your app subscriptions." />

          <Paper className={classes.paper}>
            {
              isAuthenticatedCustomer() || isUnauthenticatedCustomer() ?
              <ChargesCustomer customerAccountId={acctId}
                pg="myCharges"
                auth={this.props.auth} />
              : <Charges customerAccountId={acctId}
                  pg="myCharges"
                  auth={this.props.auth} />
            }
          </Paper>
        </div>
      );
    } else {
      return <Redirect to='/home' />;
    }
  }
}

export default withStyles(styleSheet)(MyCharges);
